import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#E0EBEE",
  "fill-rule": "evenodd",
  d: "M15.135 22.14v-4.388c1.001 0 2.764-.084 2.764-4.09V11.58h-4.272V2.94h8.64V13.662c0 3.15-.815 5.489-2.596 6.952-1.232 1.013-2.692 1.526-4.536 1.526Zm-10.56 0v-4.388c1.001 0 2.764-.084 2.764-4.09V11.58H3.067V2.94h8.64V13.662c0 3.15-.815 5.489-2.596 6.952-1.232 1.013-2.692 1.526-4.536 1.526Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }